<template>
  <div>
    <v-card
      elevation="0"
      max-width="900px"
      class="mx-auto mt-5"
      :loading="isLoading"
    ></v-card>
    <v-card
      elevation="0"
      max-width="900px"
      class="mx-auto mt-5"
      v-if="vData.status == 'Failed'"
      :loading="isLoading"
    >
      <v-card-text class="pa-8">
        <v-alert border="left" outlined prominent text type="error">{{
          vData.message
        }}</v-alert>
      </v-card-text>
    </v-card>
    <div v-if="vData.status == 'Success'">
      <Lfw v-if="$store.state.eventInfo.TemplateId == 1"></Lfw>
      <Pkl v-else-if="$store.state.eventInfo.TemplateId == 2"></Pkl>
      <IccTeamReg
        v-else-if="$store.state.eventInfo.TemplateId == 11"
      ></IccTeamReg>
      <DnaEvent v-else-if="$store.state.eventInfo.TemplateId == 3"></DnaEvent>
      <SMatch v-else-if="$store.state.eventInfo.TemplateId == 4"></SMatch>
      <Icc v-else-if="$store.state.eventInfo.TemplateId == 5"></Icc>
      <PklWid v-else-if="$store.state.eventInfo.TemplateId == 6"></PklWid>
      <Icc v-else-if="$store.state.eventInfo.TemplateId == 7"></Icc>
      <Ioc v-else-if="$store.state.eventInfo.TemplateId == 9"></Ioc>
      <SuperCross
        v-else-if="$store.state.eventInfo.TemplateId == 10"
      ></SuperCross>
      <Nmacc v-else-if="$store.state.eventInfo.TemplateId == 8"></Nmacc>
    </div>
  </div>
</template>

<script>
import Lfw from "../components/templates/lfw";
import Pkl from "../components/templates/pkl";
import DnaEvent from "../components/templates/dnaEvent";
import SMatch from "../components/templates/sMatch";
import Icc from "../components/templates/icc";
import PklWid from "../components/templates/pklWid";
import Nmacc from "../components/templates/nmacc";
import Ioc from "../components/templates/ioc";
import SuperCross from "../components/templates/superCross";
import IccTeamReg from "../components/templates/iccform/teamReg";

export default {
  props: { LinkId: String },
  components: {
    Lfw,
    Pkl,
    DnaEvent,
    SMatch,
    Icc,
    PklWid,
    Nmacc,
    Ioc,
    SuperCross,
    IccTeamReg,
  },
  data: () => ({
    vData: {},
    isLoading: false,
  }),
  async mounted() {
    this.$store.commit("setPageTitle", "New Application");
    this.isLoading = true;
    await this.$axios
      .post("/Vendor/vendorLinkData", { linkid: this.LinkId })
      .then(async (res) => {
        this.vData = res.data;
        res.data.result.link_id = this.LinkId;
        if (res.data.status == "Success") {
          await this.$store.commit("setEventInfoLink", res.data.result);
        }
        this.isLoading = false;
      });
  },
};
</script>

<style>
</style>